import { CLEAR_OUTPUT, RESET_OUTPUT } from "../../config/constants";
import useCommandFlowStore from "../../store/commandFlowStore";

export async function handleSpecialOutput({
  result,
  setCurrentPrompt,
  setInSession,
  initMessage,
  onCommandComplete,
  incrementResetToken, // Add this parameter
  engine,
}) {
  const setOutput = useCommandFlowStore.getState().setOutput;
  const addOutputWithTypingEffect =
    useCommandFlowStore.getState().addOutputWithTypingEffect;

  if (result.output === CLEAR_OUTPUT) {
    const setWasCleared = useCommandFlowStore.getState().setWasCleared;

    // Immediately clear the terminal without showing any message
    setOutput([]);
    setWasCleared(true); // Mark that output was intentionally cleared
    setCurrentPrompt(null);
    setInSession(false);
    // Reset typing/processing flags so the prompt input reappears
    useCommandFlowStore.getState().setIsTyping(false);
    useCommandFlowStore.getState().setIsAwaitingPrompt(false);
    useCommandFlowStore.getState().setIsSkippableDelay(false);
    useCommandFlowStore.getState().setIsLoading(false);
    if (onCommandComplete && engine) {
      const commandName = engine.currentCommandName;
      const sessionData = engine.sessionManager.steplessSessionData || {};
      onCommandComplete(commandName, sessionData);
      // Clear currentCommandName and steplessSessionData after callback is invoked
      engine.sessionManager.currentCommandName = null;
      engine.sessionManager.steplessSessionData = null;
    }

    return true;
  }
  if (result.output === RESET_OUTPUT) {
    // Clear output first
    setOutput([]);

    // Add initial message with typing effect
    if (initMessage && initMessage.length > 0) {
      // Convert string messages to proper format if needed
      const formattedMessages = initMessage.map((msg) =>
        typeof msg === "string" ? { type: "output", text: msg } : msg
      );
      await addOutputWithTypingEffect(formattedMessages);
    }

    setCurrentPrompt(null);
    setInSession(false);
    incrementResetToken(); // Use the passed-in function
    if (onCommandComplete) {
      onCommandComplete();
    }
    return true;
  }
  return false;
}
